
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CustomButton extends Vue {
  /**
   * Size of the button. Can be 'large' or 'small'.
   */
  @Prop({ default: 'large' }) private size!: string;

  /**
   * Variant of the button. Can be 'primary', 'secondary', 'text', 'icon', 'link'.
   */
  @Prop({ default: 'primary' }) variant!: string;

  @Prop(Boolean) private fullWidth!: boolean;

  @Prop({ default: '' }) dataTest!: string;

  @Prop({ default: 'OK' }) label!: string;

  @Prop({ default: 'button' }) type!: string;

  get classList() {
    const variantClass = `button-${this.variant}`;
    const sizeClass = `button-${this.size}`;
    const width = this.fullWidth ? 'full-width' : '';
    return [variantClass, sizeClass, width];
  }

  get dataTestAttr(): string {
    if (this.dataTest) return this.dataTest;
    return `${this.label.split(' ')[0].toLocaleLowerCase()}Btn`;
  }
}
